import * as React from 'react';
import { SVGProps } from 'react';

const IconWatchFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1-10.52V4h-2v8.52l5.427 3.8 1.146-1.64L13 11.48z"
    />
  </svg>
);
export default IconWatchFilledSizeM;
